import { render, staticRenderFns } from "./DashboardFollowUp.vue?vue&type=template&id=385ddcd8&scoped=true&"
import script from "./DashboardFollowUp.vue?vue&type=script&lang=js&"
export * from "./DashboardFollowUp.vue?vue&type=script&lang=js&"
import style1 from "./DashboardFollowUp.vue?vue&type=style&index=1&id=385ddcd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385ddcd8",
  null
  
)

export default component.exports